import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { UserMultiPicker } from './UserMultiPicker';

export const GROUP_COLORS = {
  amber: 'bg-amber-500', cyan: 'bg-cyan-500', emerald: 'bg-emerald-500',
  rose: 'bg-rose-500', blue: 'bg-blue-500', slate: 'bg-slate-400',
};

export const GroupEditorDialog = ({ open, group, users, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [color, setColor] = useState('amber');
  const [memberIds, setMemberIds] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName(group?.name || '');
    setDescription(group?.description || '');
    setColor(group?.color || 'amber');
    setMemberIds(group?.member_ids || []);
  }, [open, group]);

  const save = async () => {
    setSaving(true);
    await onSave({ name, description, color, member_ids: memberIds });
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-slate-800 border-slate-700 text-white max-h-[92vh] overflow-y-auto" data-testid="group-editor">
        <DialogHeader>
          <DialogTitle>{group ? 'Modifica gruppo' : 'Nuovo gruppo'}</DialogTitle>
          <DialogDescription className="text-slate-400">Es. "Microsoft — Team Sales". Puoi includere lead e clienti.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-[1fr_auto] gap-3">
          <input
            value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome del gruppo"
            className="px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm" data-testid="group-name-input"
          />
          <div className="flex items-center gap-1.5">
            {Object.entries(GROUP_COLORS).map(([k, cls]) => (
              <button
                type="button" key={k} onClick={() => setColor(k)}
                className={`w-6 h-6 rounded-full ${cls} ${color === k ? 'ring-2 ring-white ring-offset-2 ring-offset-slate-800' : 'opacity-60'}`}
                data-testid={`group-color-${k}`} aria-label={k}
              />
            ))}
          </div>
        </div>
        <input
          value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descrizione (opzionale)"
          className="px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm" data-testid="group-desc-input"
        />
        <UserMultiPicker users={users} selected={memberIds} onChange={setMemberIds} testIdPrefix="group-members" />
        <div className="flex justify-end gap-2 pt-2 border-t border-slate-700">
          <Button variant="ghost" onClick={onClose} className="text-slate-300 hover:bg-slate-700" data-testid="group-cancel-btn">Annulla</Button>
          <Button onClick={save} disabled={!name.trim() || saving} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="group-save-btn">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Salva gruppo
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
